export default "__VITE_ASSET__75ee76b3__"